import { gsap, quickVar } from '../lib/gsap';
import { prefersReducedMotion } from '../lib/lenis';

// The hero mesh and the phone lean towards the pointer. Each blob declares its
// own depth via data-hero-blob, so they drift at different rates.
export function initHeroParallax(): void {
  const hero = document.querySelector<HTMLElement>('[data-hero-parallax]');
  if (!hero) return;
  if (prefersReducedMotion() || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const blobs = Array.from(hero.querySelectorAll<HTMLElement>('[data-hero-blob]')).map((el) => ({
    depth: parseFloat(el.dataset.heroBlob || '16'),
    setX: quickVar(el, '--shift-x', 'px', 0.6),
    setY: quickVar(el, '--shift-y', 'px', 0.6),
  }));

  const phone = hero.querySelector<HTMLElement>('[data-hero-phone]');
  const phoneTo = phone
    ? {
        rotateY: gsap.quickTo(phone, 'rotationY', { duration: 0.6, ease: 'power3.out' }),
        rotateX: gsap.quickTo(phone, 'rotationX', { duration: 0.6, ease: 'power3.out' }),
        x: gsap.quickTo(phone, 'x', { duration: 0.6, ease: 'power3.out' }),
        y: gsap.quickTo(phone, 'y', { duration: 0.6, ease: 'power3.out' }),
      }
    : null;

  if (phone) {
    gsap.set(phone, { transformPerspective: 1400, transformStyle: 'preserve-3d' });
  }

  hero.addEventListener(
    'mousemove',
    (event) => {
      const rect = hero.getBoundingClientRect();
      const px = (event.clientX - rect.left) / rect.width - 0.5;
      const py = (event.clientY - rect.top) / rect.height - 0.5;

      blobs.forEach(({ depth, setX, setY }) => {
        setX(px * depth);
        setY(py * depth);
      });

      if (phoneTo) {
        phoneTo.rotateY(-px * 5);
        phoneTo.rotateX(py * 4);
        phoneTo.x(px * 10);
        phoneTo.y(py * 6);
      }
    },
    { passive: true },
  );

  hero.addEventListener('mouseleave', () => {
    blobs.forEach(({ setX, setY }) => {
      setX(0);
      setY(0);
    });
    if (phoneTo) {
      phoneTo.rotateY(0);
      phoneTo.rotateX(0);
      phoneTo.x(0);
      phoneTo.y(0);
    }
  });
}
